<template>
  <b-modal :id="modalId" hide-footer size="lg" title="이미지 미리보기" centered>
    <div style="display: flex; overflow-x: auto; gap: 12px; padding: 8px 0;">
      <b-img
        v-for="(img, idx) in images"
        :key="idx"
        :src="img.url"
        style="max-height: 500px; width: auto; flex-shrink: 0;"
      />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ImagePreviewModal",
  props: {
    modalId: {
      type: String,
      required: true,
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
